import React from "react";
import clsx from "clsx";

import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { ROW_CHECK_OPTIONS } from "./options";
import { LOCALIZE_NAME_OPTIONS } from "~/constans/commom";

import Button from "~/shared/ui/Fields/Button";

import IconPng from "~/components/Icons/mimeType/icon-png";
import IconJpeg from "~/components/Icons/mimeType/icon-jpeg";
import IconZip from "~/components/Icons/mimeType/icon-zip";
import IconBmp from "~/components/Icons/mimeType/icon-bmp";
import IconCsv from "~/components/Icons/mimeType/icon-csv";
import IconDoc from "~/components/Icons/mimeType/icon-doc";
import IconGif from "~/components/Icons/mimeType/icon-gif";
import IconGzip from "~/components/Icons/mimeType/icon-gzip";
import IconPpt from "~/components/Icons/mimeType/icon-ppt";
import IconRar from "~/components/Icons/mimeType/icon-rar";
import IconSvg from "~/components/Icons/mimeType/icon-svg";
import IconTxt from "~/components/Icons/mimeType/icon-txt";
import IconWebp from "~/components/Icons/mimeType/icon-webp";
import IconWbmp from "~/components/Icons/mimeType/icon-wbmp";
import IconTiff from "~/components/Icons/mimeType/icon-tiff";
import IconXls from "~/components/Icons/mimeType/icon-xls";
import Icon7zip from "~/components/Icons/mimeType/icon-7zip";
import IconPdf from "~/components/Icons/mimeType/icon-pdf";
import IconInfo from "~/components/Icons/info";
import IconCheck from "~/components/Icons/icon-check-mark";
import IconCross from "~/components/Icons/icon-cross";
import IconUnknow from "~/components/Icons/mimeType/icon-unknow-file";
import Violation from "~/components/Icons/icon-violations";
import Warning from "~/components/Icons/alert-square";
import Delete from "~/components/Icons/delete-cross";
import s from "./TableRow.less";
import Default from "~/components/Icons/icon-default";
import { usePermissions } from "~/shared/context/PermissionContext";
import { useUser } from "~/shared/context/UserContext";
import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";

interface IProps {
  options: string[];
  type: string;
  btnEdit?: boolean;
  item;
}

const AccoutingPeriodTableRow: React.FC<IProps> = ({
  options = [],
  item = {},
  btnEdit = false,
  type,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { dealerChoice } = useUser();
  const { sortField } = useGetLocationData();
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const currentDealerId = useCurrentDealerId();

  let lang = localStorage.getItem("language");
  const setData = useSetLocationData();

  const isUsersType = type === "users";
  const { searchTextForSelect } = useGetLocationData();
  const restore = type === "editorSubdivision" || item.status === "active";

  const goToId = (el) => {
    el === "Year"
      ? dealerChoice === "one"
        ? history.push(`/accounting/${item.id}/${currentDealerId}`)
        : history.push(`/accounting/${item.id}`)
      : el === "DealerName" &&
        hasPermission("accounting.getPeriod") &&
        history.push(
          `/accounting/${item.period}/${item.idDealer}?searchTextForSelect=${searchTextForSelect}`
        );
  };

  const IconMimeType = (elem) => {
    const mimeType = elem.mimeType;
    const re = /(?:\.([^.]+))?$/;
    const point = re.exec(elem.link)[1];

    let icon = {};
    switch (mimeType) {
      case "image/png":
        icon = <IconPng />;

        break;
      case "image/jpeg":
        icon = <IconJpeg />;
        break;
      case "image/pjpeg":
        icon = <IconJpeg />;
        break;
      case "image/bmp":
        icon = <IconBmp />;
        break;
      case "image/x-windows-bmp":
        icon = <IconBmp />;
        break;
      case "image/csv":
        icon = <IconCsv />;
        break;
      case "image/webp":
        icon = <IconWebp />;
        break;
      case "image/vnd.wap.wbmp":
        icon = <IconWbmp />;
        break;
      case "image/gif":
        icon = <IconGif />;
        break;
      case "application/pdf":
        icon = <IconPdf />;
        break;
      case "image/svg+xml":
        icon = <IconSvg />;
        break;
      case "image/tiff":
        icon = <IconTiff />;
        break;
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        icon = <IconDoc />;
        break;
      case "application/msword":
        icon = <IconDoc />;
        break;
      case "application/vnd.ms-excel":
        icon = <IconXls />;
        break;
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        icon = <IconXls />;
        break;
      case "application/zip":
        icon = <IconZip />;
        break;
      case "application/x-zip-compressed":
        icon = <IconZip />;
        break;
      case "application/gzip":
        icon = <IconGzip />;
        break;
      case "application/x-rar-compressed":
        icon = <IconRar />;
        break;
      case "application/vnd.rar":
        icon = <IconRar />;
        break;
      case "application/x-rar":
        icon = <IconRar />;
        break;
      case "application/vnd.ms-powerpoint":
        icon = <IconPpt />;
        break;
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        icon = <IconPpt />;
        break;
      case "application/x-7z-compressed":
        icon = <Icon7zip />;
        break;
      case "text/plain":
        icon = <IconTxt />;
        break;
      case "application/octet-stream":
        if (point == "rar") {
          icon = <IconRar />;
        } else if (point == "wbmp") {
          icon = <IconWbmp />;
        }
        break;
      default:
        icon = <IconUnknow />;
        break;
    }

    return icon;
  };

  const openEditModal = () => {
    setData("openModal", "Edit", "currentId", item.id);
  };

  return (
    <>
      <tr className={s.row_tr}>
        {options?.map((optionName) => (
          <td
            style={{ maxWidth: 100, overflow: "hidden" }}
            key={optionName}
            className={clsx({
              [s.sort_active]: sortField === optionName,
              // (type === "indicators"
              //   ? optionName === "name"
              //     ? commonName
              //     : optionName
              //   : LOCALIZE_NAME_OPTIONS.includes(optionName) && lang === "en"
              //     ? `${optionName}En`
              //     : optionName)
            })}
            data-option_name={optionName}
            onClick={() => goToId(optionName)}
          >
            <div>
              {optionName !== "Files" ? (
                <span className={s.cont}>{item[optionName]}</span>
              ) : (
                !!item.Files.length &&
                item.Files.map((el) => {
                  return (
                    <span className={s.cont}>
                      <a
                        href={el.link}
                        download
                        target="_blank"
                        placeholder={el.name}
                      >
                        {IconMimeType(el)}
                      </a>{" "}
                    </span>
                  );
                })
              )}
            </div>
          </td>
        ))}
        {btnEdit && (
          <td className={s.with_btn}>
            <div className={s.cont}>
              <Button small txtBtn={t("ui.btn_edit")} onClick={openEditModal}>
                <Default />
              </Button>
            </div>
          </td>
        )}
      </tr>
    </>
  );
};
export default AccoutingPeriodTableRow;
